export const appConfig = {
    backendUrl: 'https://qa6.srw.aisnovations.com',
    redirectOnError: false,
};